/**
 * Global application constants
 */

// API base configuration (set via .env files)
// Fallback to production API URL if .env is not set
export const API_PREFIX = process.env.REACT_APP_API_PREFIX ?? (process.env.NODE_ENV === 'production' ? '/api' : '');
export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN ?? (process.env.NODE_ENV === 'production' ? 'https://hr.ultracleaning.com.my' : '');
export const API_URL = `${API_ORIGIN}${API_PREFIX}`;

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  auth: {
    login: `/auth/Access`
  },
  user:{
    updateUserToken: `/user/UpdateUserToken`
  },
  // Lookup endpoints
  lookup: {
    getLookupById: (id: number) => `/lookup/GetLookup/${id}`,
    getRecommendations: `/lookup/getrecommendation`,
    getPestTypes: `/lookup/GetPestType`,
    getInfestationTypes: `/lookup/InfestationType`,
    // HR: Leave types master list
    getLeaveTypes: `/lookup/GetLeaveType`,
    // Document types
    getDocumentTypes: `/lookup/GetDocumentType`,
    // Transaction types
    getTransactionTypes: `/lookup/GetTransactionType`,
    // Collection methods
    getCollectionMethods: `/lookup/GetCollectionMethod`
  },
  
  // Schedule endpoints
  schedule: {
    base: `/schedule`,
    getOrder: (id: number) => `/schedule/GetOrder/${id}`,
    getUpcomingServices: `/schedule/GetUpcomingServices`,
    getHistory: `/schedule/GetHistory`,
    getCustomerHistory: (id: string | number) => `/schedule/GetCustomerHistory/${id}`,
    uploadImage: (id: string | number) => `/schedule/uploadimage/${id}`,
    getSchedule: (id: string | number) => `/Schedule/GetSchedule/${id}`,
    getImages: (id: string | number) => `/schedule/GetImages/${id}`,
    printServiceReport: (id: string | number) => `/Schedule/PrintServiceReport/${id}`,
    getDashboard: `/schedule/GetDashboard`,
    getPendingSignatureCustomer: `/schedule/GetPendingSignatureCustomer`,
    updateManagerWorkingDateTime: (id: string | number) => `/schedule/updateManagerWorkingDateTime/${id}`
  },
  
  // Profile endpoints
  profile: {
    updateProfile: `/profile/UpdateProfile`,
    leaveApplication: `/profile/LeaveApplication`,
    updateLeaveApplication: `/profile/UpdateLeaveApplication`,
    downloadLeaveDocument: (id: number | string, fileName: string) => `/profile/LeaveDocument/${id}?fileName=${encodeURIComponent(fileName)}`,
    deleteLeave: (id: number | string) => `/Profile/DeleteLeave/${id}`,
    getDocuments: (documentTypeId: number) => `/Profile/GetDocument/${documentTypeId}`,
    getDownloadDocument: (documentTypeId: number) => `/profile/GetDownloadDocument/${documentTypeId}`,
    getFeed: `/profile/feed`,
    getTasks: `/profile/tasks`,
    markTaskComplete: (taskId: string | number) => `/profile/tasks/${taskId}/complete`,
    getTimeLineFile: (id: string | number, fileName: string) => `/Profile/GetTimeLineFile/${id}?fileName=${encodeURIComponent(fileName)}`,
    // Transaction requests
    transactionRequest: `/profile/TransactionRequest`,
    updateTransactionRequest: (id: number | string) => `/profile/UpdateTransaction/${id}`,
    updateSignature: (id: number | string) => `/profile/UpdateSignature/${id}`,
    getTransactionRequests: `/profile/GetTransactionRequests`,
    deleteTransactionRequest: (id: number | string) => `/profile/DeleteTransaction/${id}`
  },
  
  // Pest control endpoints
  pestControl: {
    submit: `/pest-control/submit`
  },

  // Report endpoints
  report: {
    getSummary: `/report/GetSummary`
  },

  // Management endpoints
  management: {
    getManagerListing: `/Management/GetManagerListing`,
    getHistory: `/Management/GetHistory`,
    getPendingJob: `/Management/GetPendingJob`,
    getManager: `/Management/GetManager`,
    updateScheduleManager: `/Management/UpdateScheduleManager`
  }
};

// Other app constants can be added here 